export enum Env {
  UNDEFINED = 'UNDEFINED',
  LOCAL = 'LOCAL',
  PROD = 'PROD',
}
